/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import {ReportTypeCode} from './reportTypeCode';


export interface EditableReportListItemDTO {
  code?: ReportTypeCode;
  state?: EditableReportListItemDTO.StateEnum;
  year?: number;
}

export namespace EditableReportListItemDTO {
  export type StateEnum = 'NOT_CREATED' | 'OPEN' | 'FINISHED';
  export const StateEnum = {
    NotCreated: 'NOT_CREATED' as StateEnum,
    Open: 'OPEN' as StateEnum,
    Finished: 'FINISHED' as StateEnum
  };
}


